import { createFileRoute } from '@tanstack/react-router';
import { ProjectForecast } from '@/features/projects/ProjectForecast';

export const Route = createFileRoute('/_app/project-forecast')({ component: ProjectForecast });
